// extracted by mini-css-extract-plugin
export var fadeInOut = "_4t-3";
export var icon = "_4t-4";
export var savedIndicator = "_4t-2";
export var savingIndicator = "_4t-0";
export var spin = "_4t-1";